/**
 * t(): a message from the catalogue, formatted with ICU MessageFormat for the
 * workspace locale. Compiled messages are cached per locale and key.
 */
import { IntlMessageFormat } from "intl-messageformat";
import { brand } from "@sable/brand";
import { en, type MessageKey } from "./en.ts";

export type { MessageKey };

let locale = "en-US";
const cache = new Map<string, IntlMessageFormat>();

export function setLocale(next: string): void {
  if (next !== locale) {
    locale = next;
    cache.clear();
  }
}

export function currentLocale(): string {
  return locale;
}

export function t(key: MessageKey, values?: Record<string, string | number>): string {
  let fmt = cache.get(key);
  if (!fmt) {
    fmt = new IntlMessageFormat(en[key], locale);
    cache.set(key, fmt);
  }
  return String(fmt.format({ brand: brand.displayName, ...values }));
}

/** For enum-like values whose label key is built at run time (status.sold, slot.front …). */
export function tk(prefix: string, value: string): string {
  const key = `${prefix}.${value}` as MessageKey;
  return key in en ? t(key) : value;
}
